import { jsx as _jsx } from "react/jsx-runtime";
import ReactLoading from 'react-loading';
export default function Indicator(props) {
    var className = props.className, style = props.style;
    return(/*#__PURE__*/ _jsx("div", {
        className: "flex justify-center items-center h-[50px] w-full ".concat(className),
        style: style,
        children: /*#__PURE__*/ _jsx(ReactLoading, {
            type: "bubbles",
            color: "#9ca0b2"
        })
    }));
};
